module.exports = __webpack_public_path__ + "static/media/default_car.4d377b74.png";